var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"drag",rawName:"v-drag"}],staticClass:"me-image-mark-point",style:({
    left: `${_vm.coordinate.x}px`,
    top: `${_vm.coordinate.y}px`,
    width: `${_vm.size}px`,
    height: `${_vm.size}px`,
  }),attrs:{"slot":"reference"},on:{"click":_vm.clickPoint},slot:"reference"},[_vm._t("icon",function(){return [_c('img',{attrs:{"src":_vm.icon}})]},{"detail":_vm.point})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }